
const environment = {
    apiUrl: "https://beta.secretaria.ieadern.org.br/api/"
}

export default environment;
